/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
import { Map, Record } from 'immutable';

export interface QuotationRequestState extends Map<string, any> {

  quotationList: any;
  quotationListLoading: boolean;
  quotationListLoaded: boolean;
  quotationListFailed: boolean;

  quotationListCount: any;
  quotationListCountLoading: boolean;
  quotationListCountLoaded: boolean;
  quotationListCountFailed: boolean;


}

export const QuotationRequestStateRecord = Record({

  quotationList: [],
  quotationListLoading: false,
  quotationListLoaded: false,
  quotationListFailed: false,

  quotationListCount: '',
  quotationListCountLoading: false,
  quotationListCountLoaded: false,
  quotationListCountFailed: false,

});
